import { ConeSide } from './ConeSide';
// represents a cone side that is broken by the obstacle
export class BrokenConeSide extends ConeSide {
    get Start() {
        return this.start;
    }
    get End() {
        return this.EndVertex.point;
    }
    constructor(start, end, coneSide) {
        super();
        this.start = start;
        this.EndVertex = end;
        this.ConeSide = coneSide;
    }
    get Direction() {
        return this.End.sub(this.Start);
    }
    toString() {
        return 'BrokenConeSide: ' + (this.Start + (',' + this.End));
    }
}
//# sourceMappingURL=BrokenConeSide.js.map